export default function WelcomeContent() {
  return (
    <div>
      Welcome to Aeditto. This seems like your first time here.
      <div className='mb-3' />
      Please allow us to take you through a walkthrough of our playground.
    </div>
  )
}
